import React, { useState } from "react";
import "../../css/FaqAccordion.css";

export default function FaqAccordion({ items = [] }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <h2 className="faq-title">FAQs</h2>

      {items.map((item, index) => (
        <div key={index} className="faq-item">
          <button className="faq-question" onClick={() => toggle(index)}>
            {item.question}
            <span className={`faq-icon ${openIndex === index ? "open" : ""}`}>
              +
            </span>
          </button>

          <div className={`faq-answer ${openIndex === index ? "show" : ""}`}>
            <p>{item.answer}</p>
          </div>
        </div>
      ))}
    </section>
  );
}
